import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap"
import Filters from "components/Common/Filters"
import Switch from "components/Shared/Switch"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Paginations from "components/Common/Paginations"
import { showAlert } from "store/reducers/alertReducer"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import isPermissionEnabled from "common/isPermissionEnabled"
import TableShimmer from "components/Shared/TableShimmer"
import DeleteModal from "components/Common/DeleteModal"
import formatDateTime from "components/Shared/formatDateTime"
import {
  deleteCity,
  getAllCities,
  updateCityStatus,
  getAllCampaing,
} from "store/actions/cityAction"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"

const Campaign = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Eidiyah Deep Link| Namq")
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const countryParam = searchParams.get("country")
  const [selectedId, setSelectedId] = useState(null)
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [copySuccess, setCopySuccess] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
 
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    country: countryParam
      ? (() => {
          const [label, value] = countryParam.split(":")
          return { label, value }
        })()
      : [],
    region: [],
  })
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const {
    loading,
    isLoading,
    totalCount,
    totalPages,
    currentPage,
    itemsPerPage,
    cities,
    campaing,
    capm
  } = useSelector(state => state.City)
  const { countryList } = useSelector(state => state.Countries)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,

  })
  

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
         userRole,
         39,
         "dynamic_link_1",
         accountType
       )
   
       const isPermissionCreate = isPermissionEnabled(
         userRole,
         39,
         "dynamic_link_2",
         accountType
       )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
     
    })
  }, [userRole])

  useEffect(() => {
    getCities()
    fetchCountryList()
  }, [])

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }
  const handleCopy = (link) => {
    if (link) {
      navigator.clipboard.writeText(link)
        .then(() => {
          console.log("Link copied to clipboard");
          // Dispatch the alert after successfully copying
          dispatch(showAlert({ text: "Link copied successfully!", type: "success" }));
        })
        .catch((error) => {
          console.error("Error copying the link: ", error);
          // You could also show an error alert here if desired
          dispatch(showAlert({ text: "Failed to copy link", type: "error" }));
        });
    }
  };
  const getCities = () => {
    const {  sortOrder, country } = selectedFilters
    const countryIds = country.value ? [country.value] : []

    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      // status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
      // country: countryIds,
      // region: [],
    }
    dispatch(getAllCampaing(payload))
    setIsApiCalled(true)
  }

  const handleFetchCities = (page = 1) => {
    const { sortOrder, country } = selectedFilters
    const countryIds = country.value ? [country.value] : []

    const searchParams = new URLSearchParams()
    searchParams.set("search", searchTerm)
    
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())
    if (country.value) {
      searchParams.set("country", `${country.label}:${country.value}`)
    }

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      // status: Number(status), // 0 deactive, 1 active, 2 for all
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      // country: countryIds,
      // region: [], // Assuming `region` is an empty array in both cases
    }

    dispatch(getAllCampaing(payload))
      .then(action => {
        const { statusCode, status } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/Eidiyah-Deep-Link?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        // Handle error if needed
      })
  }

  const handleSearch = () => {
    handleFetchCities(1)
  }

  const onPageChange = page => {
    handleFetchCities(page)
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }
  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const filters = [
    // {
    //   name: "status",
    //   type: "select",
    //   options: [
    //     { label: t("All"), value: 2 },
    //     { label: t("Enabled"), value: 1 },
    //     { label: t("Disabled"), value: 0 },
    //   ],
    //   placeholder: t("All"),
    // },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    }
  ]

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters])

  const handleReset = () => {
    setSearchTerm("")
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      // status: 2,
      orderBy: 1,
      keyword: "",
      // country: [],
      // region: [],
    }
    dispatch(getAllCampaing(payload))
    // navigate(`/cities?page=${1}`)
    setSelectedFilters({
      status: 2,
      sortOrder: 1,
      country: [],
      region: [],
    })
  }



  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deleteCity(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs />
          <Row>
            <Col xl={12}>
              <Card>
                <DataExportDropdown
                  cardTitle={t("Eidiyah Deep Link")}
                  isAddBtn={loading ? false : usersPermissions.create}
                  addBtnText={t("Add Eidiyah Deep Link")}
                  onAddBtnClick={() => navigate("/Campaign/add")}
                />
                <CardBody>
                  <Filters
                    filters={filters}
                    searchTerm={searchTerm}
                    handleSearchChange={handleSearchChange}
                    handleFilterChange={handleFilterChange}
                    handleSearch={handleSearch}
                    onReset={handleReset}
                    selectedFilters={selectedFilters}
                    searchBy={t("Name")}
                    colSize={4}
                  />

                  <div className="">
                    {loading ? (
                      <TableShimmer row={7} col={5} />
                    ) : campaing.length === 0 ? (
                      <p className="text-center my-2">{t("No cities found")}</p>
                    ) : (
                      <Table className="table mb-0" hover>
                        <thead className="table-light">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Name")}</th>
                            <th>{t("Arabic")}</th>
                            <th>{t("Total Android Hit Count")}</th>
                            <th>{t("Total IOS Hit Count")}</th>
                            <th>{t("Total User HitCount")}</th>
                         
                            {/* {usersPermissions.edit &&  */}
                            <th>{t("Dynamic Link")}</th>
                            {/* } */}
                            <th>{t("Create AT")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaing.map((item, index) => (
                            <tr
                              key={item._id}
                            
                              className="cursor-pointer"
                            >
                              <th scope="row">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </th>
                              <td>
                                {language === "sa" ? item.nameAr : item.name}
                              </td>
                              <td>
                                {language === "sa" ? item.nameAr : item.nameAr}
                              </td>
                             <td>  {item?.totalAndroidHitCount} </td>
                              <td>{item?.totalIOSHitCount}</td>
                              <td>{item?.totalUserHitCount}</td>
                             
                              <td>
                              <button
      onClick={(e) => {
        e.stopPropagation(); // Prevent triggering row's onClick
        handleCopy(item?.dynamicLink); // Call the function to copy the link and show the alert
      }}
      className="copy-link-btn"
    >
      Copy Link
    </button>
            
            </td>
            <td>{formatDateTime(item?.createdAt)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                  {!loading && campaing.length > 0 && (
                    <div className="mt-3">
                      <Paginations
                        data={campaing}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalCount={totalCount}
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("City"),
        })}
      />
    </React.Fragment>
  )
}

export default Campaign
